import { useQuery } from '@apollo/client'
import { GetPDNNoteTypeReasons } from 'api/graphQL/queries/productDetailNotes.queries'
import { useCallback } from 'react'
import { setReasons } from '../PDNStore'

const usePDNReasonsHook = () => {
    // repeated these queries since there are only fixed amount of noteTypes and batching has been removed in apollo v3
    useQuery(GetPDNNoteTypeReasons, {
        variables: {
            productDetailNoteType: 'GENERALNOTE',
        },
        fetchPolicy: 'cache-first',
        onCompleted: ({ getAllowedReasonsForProductDetailNoteType }) => {
            if (!!getAllowedReasonsForProductDetailNoteType.length) {
                setReasons({
                    noteType: 'GENERALNOTE',
                    reasons: [...getAllowedReasonsForProductDetailNoteType],
                })
            }
        },
    })

    useQuery(GetPDNNoteTypeReasons, {
        variables: {
            productDetailNoteType: 'DELETEORSTATUSCHANGE',
        },
        fetchPolicy: 'cache-first',
        onCompleted: ({ getAllowedReasonsForProductDetailNoteType }) => {
            if (!!getAllowedReasonsForProductDetailNoteType.length) {
                setReasons({
                    noteType: 'DELETEORSTATUSCHANGE',
                    reasons: [...getAllowedReasonsForProductDetailNoteType],
                })
            }
        },
    })

    useQuery(GetPDNNoteTypeReasons, {
        variables: {
            productDetailNoteType: 'LISTINGTYPECHANGE',
        },
        fetchPolicy: 'cache-first',
        onCompleted: ({ getAllowedReasonsForProductDetailNoteType }) => {
            if (!!getAllowedReasonsForProductDetailNoteType.length) {
                setReasons({
                    noteType: 'LISTINGTYPECHANGE',
                    reasons: [...getAllowedReasonsForProductDetailNoteType],
                })
            }
        },
    })

    useQuery(GetPDNNoteTypeReasons, {
        variables: {
            productDetailNoteType: 'COPYMOVE',
        },
        fetchPolicy: 'cache-first',
        onCompleted: ({ getAllowedReasonsForProductDetailNoteType }) => {
            if (!!getAllowedReasonsForProductDetailNoteType.length) {
                setReasons({
                    noteType: 'COPYMOVE',
                    reasons: [...getAllowedReasonsForProductDetailNoteType],
                })
            }
        },
    })
    const initializeReasons = useCallback(() => {}, [])

    return { initializeReasons }
}

export default usePDNReasonsHook
